var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpCenter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.65 0.350002L13.65 4.35C13.55 4.45 13.5 4.57 13.5 4.71V12.88C13.5 13.31 14.01 13.54 14.33 13.25L18.33 9.65C18.44 9.56 18.5 9.42 18.5 9.28V0.710002C18.5 0.260002 17.96 0.0400017 17.65 0.350002ZM21.97 4.2C21.5 3.96 21.01 3.76 20.5 3.59V15.62C19.36 15.21 18.19 15 17 15C15.1 15 13.22 15.54 11.5 16.58V4.48C9.88 3.55 8.01 3 6 3C4.21 3 2.52 3.44 1.03 4.2C0.7 4.36 0.5 4.71 0.5 5.08V17.16C0.5 17.92 1.31 18.39 1.98 18.03C3.19 17.4 4.55 17 6 17C8.07 17 9.98 17.82 11.5 19C13.02 17.82 14.93 17 17 17C18.45 17 19.81 17.4 21.02 18.04C21.69 18.4 22.5 17.93 22.5 17.17V5.08C22.5 4.71 22.3 4.36 21.97 4.2Z",
    fill: "#202223"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCenter);
export default __webpack_public_path__ + "static/media/helpCenter.e88f879cbcb8da35c6747a706f394a15.svg";
export { ForwardRef as ReactComponent };